import { FieldType } from 'src/Common/Filters/interfaces/FiltersView';

export const AMMFilterConfig = [
  {
    fieldId: 'ID',
    fieldName: 'ID',
    fieldType: FieldType.TextField,
    internalName: 'raidid',
    responseFormat: 'number',
  },
  {
    fieldId: 'Title',
    fieldName: 'Title',
    fieldType: FieldType.TextField,
    internalName: 'fields/title',
    responseFormat: 'string',
  },
  {
    fieldId: 'ActionOwner',
    fieldName: 'Action Owner',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/assignedto/uniquename',
    responseFormat: 'string',
  },
  {
    fieldId: 'State',
    fieldName: 'State',
    fieldType: FieldType.Dropdown,
    fieldDropdownName: 'workItemStates',
    keyName: 'Name',
    internalName: 'fields/state',
    responseFormat: 'string',
  },
  {
    fieldId: 'Account',
    fieldName: 'Account',
    fieldType: FieldType.TextField,
    internalName: 'fields/account',
    responseFormat: 'string',
  },
  {
    fieldId: 'SubState',
    fieldName: 'Sub State',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'subStates',
    keyName: 'subState',
    internalName: 'fields/substate',
    responseFormat: 'string',
  },
  {
    fieldId: 'Requestor',
    fieldName: 'Requestor',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/requestorsinfo/uniquename',
    responseFormat: 'arrayOfObjects',
  },
  {
    fieldId: 'RequestedDate',
    fieldName: 'Requested Date',
    fieldType: FieldType.DatePicker,
    internalName: 'fields/requesteddate',
    responseFormat: 'date',
  },
  {
    fieldId: 'Contributor1',
    fieldName: 'Contributor 1',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/contributorsinfo/uniquename',
    responseFormat: 'arrayOfObjects',
  },
  {
    fieldId: 'Contributor2',
    fieldName: 'Contributor 2',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/contributorsinfo/uniquename',
    responseFormat: 'arrayOfObjects',
  },
  {
    fieldId: 'AccountableExec',
    fieldName: 'Accountable Exec',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/accountableexec/uniquename',
    responseFormat: 'string',
  },
  {
    fieldId: 'MeetingType',
    fieldName: 'Meeting Type',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'meetingTypeOrigins',
    keyName: 'meetingTypeOrigin',
    internalName: 'fields/meetingtype',
    responseFormat: 'string',
  },
  {
    fieldId: 'Areas',
    fieldName: 'Area(s)',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'areas',
    keyName: 'area',
    internalName: 'fields/areafield',
    responseFormat: 'string',
  },
];
